import { render } from "./FaqCategoryList.vue?vue&type=template&id=1ece30fe"
import script from "./FaqCategoryList.vue?vue&type=script&lang=js"
export * from "./FaqCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__